// extracted by mini-css-extract-plugin
module.exports = {"tagDetails":"customTableBoAnimalActivity_tagDetails__PFV93","summary":"customTableBoAnimalActivity_summary__2VKd8"};